import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';

export const EXPERIMENT_COOKIE = 'cn_experiment_cookie_v2';

export function getUserExperimentId() {
  const cookies = new Cookies();
  return cookies.get(EXPERIMENT_COOKIE);
}

export function setExperimentCookie() {
  const cookies = new Cookies();
  // Set a 30 day cookie to store a UUID client side
  // Used for Launch Darkly experiments
  const activeCookieValue = cookies.get(EXPERIMENT_COOKIE);

  const expires = new Date();
  expires.setHours(expires.getDate() + 30 * 24); // 30 days from now

  const cookieAttrs = { expires, domain: '.chownow.com', path: '/' };

  if (!activeCookieValue) {
    // The experiment cookie isn't set. Set it here.
    cookies.set(EXPERIMENT_COOKIE, `diner-${uuidv4()}`, cookieAttrs);
  } else {
    // The experiment cookie already exists. Rewrite it with the same value ensuring the domain is correct
    cookies.set(EXPERIMENT_COOKIE, `${activeCookieValue}`, cookieAttrs);
  }
}
